module.exports = __webpack_public_path__ + "static/media/img2-3.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/nutricheck_foliar/K/img2-3.png
// module id = 2440
// module chunks = 3